<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Tax Declaration {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.ApprovalStatus) == 'pendingwithsenior'}">{{DetailData.ApprovalStatus}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Photo != null && DetailData.Photo != ''" mat-card-image
                                            class="userImage" [src]="common.PhotoLink(DetailData.Photo)" />
                                        <div *ngIf="DetailData.Photo == null || DetailData.Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.EmployeeName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.EmployeeName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.EmpCode}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{DetailData.DesignationName}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto text-end">
                                <label for="RequestDate" class="text-label-light">Request Date</label> <br />
                                <label name="RequestDate" class="text-label-dark">{{DetailData.RequestDate}}</label>
                            </div>
                        </div>
                        <div style="background-color:#0078d42e;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-5">
                                    <label for="FromDate" class="text-label-light">Financial Year Start</label> <br />
                                    <label name="FromDate" class="text-label-dark">{{DetailData.FinancialYearStart |
                                        date :'dd MMM yyyy'}}</label>
                                </div>
                                <div class="col-md-5">
                                    <label for="ToDate" class="text-label-light">Financial Year End</label> <br />
                                    <label name="ToDate" class="text-label-dark">{{DetailData.FinancialYearEnd | date
                                        :'dd MMM yyyy'}}</label>
                                </div>
                                <div class="col-md-2">
                                    <label for="NoOfDays" class="text-label-light">Regime</label> <br />
                                    <label name="NoOfDays"
                                        class="text-label-dark">{{DetailData.IsNewRegime?'New':'Old'}}</label>
                                </div>
                            </div>
                        </div>

                        <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?'Client Location' :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?'Branch':''}}</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?DetailData.ClientLocation :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?DetailData.BranchName:''}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ps-1">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="card">
                                <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                                <div class="card-body" *ngIf="isApprovalLavel">
                                    <div id="content">
                                        <ul class="timeline">
                                            <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3 class="m-0">
                                                            {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="Remark" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    [ngClass]="{'is-invalid': this.Filter.isShowError}"
                                                    (change)="removeError()"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">

                                                <div class="invalid-feedback"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1 && this.Filter.isShowError">
                                                    Please Enter Remark!
                                                </div>
                                                <hr />
                                            </li>
                                            <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                            </li>
                                            <li class="event p-0 m-0">
                                                <div class="row">
                                                    <h3>Submitted on</h3>
                                                </div>
                                                <label class="date">{{DetailData.RequestDate}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-briefcase px-2"></i>Previous Employment Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardPreviousEmployment?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardPreviousEmployment"
                                    (change)="onSwitchChange($event,'CardPreviousEmployment')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardPreviousEmployment">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <!-- <th class="sticky-col">Month</th>
                                                    <th class="sticky-col">Year</th> -->
                                                    <th>Remark</th>
                                                    <th>Basic</th>
                                                    <th>DA</th>
                                                    <th>HRA</th>
                                                    <th>Allowance</th>
                                                    <th>Gross</th>
                                                    <th>PT</th>
                                                    <th>PF</th>
                                                    <th>TDS</th>
                                                    <th>Deduction</th>
                                                    <th>Net</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let element of TablesData.Table2; let i = index">
                                                    <!-- <td class="sticky-col">{{element.Monthname}}</td>
                                                    <td class="sticky-col text-end">{{element.Yearname}}</td> -->
                                                    <td>{{element.Remarks}}</td>
                                                    <td class="text-end">{{element.Basic}}</td>
                                                    <td class="text-end">{{element.DA}}</td>
                                                    <td class="text-end">{{element.HRA}}</td>
                                                    <td class="text-end">{{element.OtherAllowance}}</td>
                                                    <td class="text-end">{{element.GrossAmount}}</td>
                                                    <td class="text-end">{{element.PT}}</td>
                                                    <td class="text-end">{{element.PF}}</td>
                                                    <td class="text-end">{{element.TDS}}</td>
                                                    <td class="text-end">{{element.OtherDeduction}}</td>
                                                    <td class="text-end">{{element.NetAmount}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-card-checklist px-2"></i>Chapter VI A Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Section Code</th>
                                                    <th>Section</th>
                                                    <th>IncomeHead</th>
                                                    <th>Sub Section</th>
                                                    <th>Limit Applicable</th>
                                                    <th>Max Limit</th>
                                                    <th>Declared Amount</th>
                                                    <th>Approved Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let element of TablesData.Table; let i = index">
                                                    <td>{{element.SectionCode}}</td>
                                                    <td>{{element.SectionName}}</td>
                                                    <td>{{element.IncomeHead}}</td>
                                                    <td>{{element.SubSectionName}}</td>
                                                    <td>{{this.DetailData.IsNewRegime?element.IsNewMaxlimitapplicable?'Yes':'No':element.IsOldMaxlimitapplicable?'Yes':'No'}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{this.DetailData.IsNewRegime?element.IsNewMaxlimitapplicable?element.NewRegimeMaxAmount:'':element.OldRegimeMaxAmount?'Yes':'No'}}
                                                    </td>
                                                    <td class="text-end">{{element.DeclaredAmount}}</td>
                                                    <td class="text-end">
                                                        <input *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1)" type="text"
                                                            class="form-control custom-control" placeholder="Ex. 10000"
                                                            name="TaxDeclarationApprovedAmount{{i}}"
                                                            [(ngModel)]="element.ApprovedAmount"
                                                            #TaxDeclarationApprovedAmount="ngModel" pattern="^[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true)" maxlength="6"
                                                            required>

                                                        <div *ngIf="!((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1))">{{element.ApprovedAmount}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-house px-2"></i>Are you staying in a rented house?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_HRA?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_HRA"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_HRA')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_HRA">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>FromDate</th>
                                                    <th>ToDate</th>
                                                    <th>Name Of Landloard</th>
                                                    <th>Land LordPanNo</th>
                                                    <th>Address</th>
                                                    <th>IsMetroCity</th>
                                                    <th>DeclaredAmount</th>
                                                    <th>ApprovedAmount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let element of TablesData.Table1; let i = index">
                                                    <td>{{element.FromDate}}</td>
                                                    <td>{{element.ToDate}}</td>
                                                    <td>{{element.NameOfLandlord}}</td>
                                                    <td>{{element.LandLordPanNo}}</td>
                                                    <td>{{element.Address}}</td>
                                                    <td>{{element.IsMetroCity?'Yes':'No'}}</td>
                                                    <td class="text-end">{{element.DeclaredAmount}}</td>
                                                    <td class="text-end">
                                                        <input *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1)" type="text"
                                                            class="form-control custom-control" placeholder="Ex. 10000"
                                                            name="TaxDeclaration_HRAApprovedAmount{{i}}"
                                                            [(ngModel)]="element.ApprovedAmount"
                                                            #TaxDeclaration_HRAApprovedAmount="ngModel"
                                                            pattern="^[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true)" maxlength="6"
                                                            required>
                                                    </td>
                                                    <div *ngIf="!((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1))">{{element.ApprovedAmount}}</div>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-house-fill px-2"></i>Home Loan for Self-Occupied House Property
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.ESS_EmpTaxDeclarationDetails_SOP?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.ESS_EmpTaxDeclarationDetails_SOP" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'ESS_EmpTaxDeclarationDetails_SOP')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.ESS_EmpTaxDeclarationDetails_SOP">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>Annual Interest Paid/Payable</th>
                                                        <th>Principal Repayment Amount</th>
                                                        <th>Lender Name</th>
                                                        <th>Lender PAN No</th>
                                                        <th>Property Address</th>
                                                        <th>Possession Date</th>
                                                        <th>Co-Owned Property (Yes/No)</th>
                                                        <th>Co-Owner Name</th>
                                                        <th>Co-Owner Share (%)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of TablesData.Table6; let i = index">
                                                        <td>{{element.AnnualInterestPaidORPayable}}</td>
                                                        <td>{{element.PrincipalRepaymentAmount}}</td>
                                                        <td>{{element.LenderName}}</td>
                                                        <td>{{element.LenderPANNo}}</td>
                                                        <td>{{element.PropertyAddress}}</td>
                                                        <td>{{element.PossessionDate}}</td>
                                                        <td>{{element.CoOwnedProperty}}</td>
                                                        <td>{{element.CoOwnerName}}</td>
                                                        <td>{{element.CoOwnerSharePerc}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-cash-stack px-2"></i>Are you receiving rental income from Let out
                                Property?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_LOP?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_LOP"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_LOP')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_LOP">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatabl table table-borderede">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Annual Rent Received</th>
                                                    <th>Municipal Taxes</th>
                                                    <th>Net AnnualValue</th>
                                                    <th>Standard Deduction 30%</th>
                                                    <th>Repaying HomeLoan</th>
                                                    <th>Principal Paid OnHomeLoan</th>
                                                    <th>Interest Paid OnHomeLoan</th>
                                                    <th>Name Of TheLender</th>
                                                    <th>Lender PanNo</th>
                                                    <th>NetIncome/Loss</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let element of TablesData.Table4; let i = index">
                                                    <td class="text-end">{{element.AnnualRentReceived}}</td>
                                                    <td class="text-end">{{element.MunicipalTaxesPaid}}</td>
                                                    <td class="text-end">{{element.NetAnnualValue}}</td>
                                                    <td class="text-end">{{element.StandardDeduction}}</td>
                                                    <td>{{element.RepayingHomeLoanForThisProperty?'Yes':'No'}}</td>
                                                    <td class="text-end">{{element.PrincipalPaidOnHomeLoan}}</td>
                                                    <td class="text-end">{{element.InterestPaidOnHomeLoan}}</td>
                                                    <td>{{element.NameOfTheLender}}</td>
                                                    <td>{{element.LenderPanNo}}</td>
                                                    <td class="text-end">{{element.NetIncomeLossFromHouseProperty}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-building px-2"></i>Other Sources of Income
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_Others?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_Others"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_Others')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_Others">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>SubSection Name</th>
                                                    <th>SubSection Description</th>
                                                    <th>Limit Applicable</th>
                                                    <th>MaxLimit Amount</th>
                                                    <th>Declared Amount</th>
                                                    <th>Approved Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let element of TablesData.Table3; let i = index">
                                                    <td>{{element.SubSectionName}}</td>
                                                    <td>{{element.SubSectionDescription}}</td>
                                                    <td>{{this.DetailData.IsNewRegime?element.IsNewMaxlimitapplicable?'Yes':'No':element.IsOldMaxlimitapplicable?'Yes':'No'}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{this.DetailData.IsNewRegime?element.IsNewMaxlimitapplicable?element.NewRegimeMaxAmount:'':element.OldRegimeMaxAmount?'Yes':'No'}}
                                                    </td>
                                                    <td class="text-end">{{element.DeclaredAmount}}</td>
                                                    <td class="text-end">

                                                        <input *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1)" type="text"
                                                            class="form-control custom-control" placeholder="Ex. 10000"
                                                            name="TaxDeclaration_OtherApprovedAmount{{i}}"
                                                            [(ngModel)]="element.ApprovedAmount"
                                                            #TaxDeclaration_OtherApprovedAmount="ngModel"
                                                            pattern="^[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true)" maxlength="6"
                                                            required>
                                                        <div *ngIf="!((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1))">{{element.ApprovedAmount}}</div>


                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-wallet px-2"></i>TDS/TCS Paid During the Year
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.ESS_EmpTaxDeclarationDetails_TDS?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.ESS_EmpTaxDeclarationDetails_TDS" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'ESS_EmpTaxDeclarationDetails_TDS')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.ESS_EmpTaxDeclarationDetails_TDS">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>TDS/TCS Paid</th>
                                                        <th>Challan No</th>
                                                        <th>Payment Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of TablesData.Table5; let i = index">
                                                        <td>{{element.TDSorTCSPaid}}</td>
                                                        <td>{{element.ChallanNo}}</td>
                                                        <td>{{element.PaymentDate}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                    class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
            <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                [routerLink]="['/incometax/compare/ad/' + this.DetailData.TransactionId]"><i
                    class="bi bi-bookmark-check" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Compare':'Loading...'}}</button>
            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-danger" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Reject')"><i
                    class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Reject':'Loading...'}}</button>

            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-success" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Approve')"><i
                    class="bi bi-check2" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Approve':'Loading...'}}</button>

            <!-- <button
                *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'approved' && GetID == 2"
                type="button" class="btn btn-warning" [disabled]="isDisabled"
                (click)="SaveEmployeeLeaveDetails()"><i class="bi bi-x-circle" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Withdraw':'Loading...'}}</button> -->
        </div>
    </div>
</div>